<template>
  <div class="container">
    <div class="alert alert-danger" v-if="error" role="alert">
      {{ error }}
    </div>
    <h3>Vill du radera Bevakningen?</h3>
    <p>
      {{ notification.MessageText }}
    </p>
    <button type="button" class="btn btn-link" @click="$router.go(-1)">Avbryt</button>
    <button type="submit" class="btn btn-danger" @click="deleteNotification">Radera</button>
  </div>
</template>
<script>
import appService from '../appService'

export default {
  props: ['id'],

  data () {
    return {
      error: '',
      notification: {}
    }
  },

  created () {
    appService.getNotification(this.id)
    .then((data) => { this.notification = data })
  },

  methods: {
    deleteNotification () {
      appService.deleteNotification(this.id)
      .then(() => { this.$router.go(-1) })
      .catch((err) => { this.error = err.response.data })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/NotificationDelete.vue